import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, color, flex, flexAbsoluteCenter, flexAlignCenter, mb, mh, mr, mt, onDesktop, p, pointer, pv, w100} from "@pg-design/helpers-css";
import {CloseIcon, WeightIcon} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

const sneakPeakSm = require("./images/comparison_tool_sneak_peak_sm.png");
const sneakPeakXl = require("./images/comparison_tool_sneak_peak_xl.png");

export const NoItemsToCompare = () => {
    const theme = useTheme();

    const textLight = color(theme.colors.gray[700]);

    const onShowListing = () => {
        window.location.replace(rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"}));
    };

    return (
        <div css={emptyDataContainer}>
            <div css={comparisonToolSneakPeak}>
                <Picture
                    css={onDesktop(css`
                        max-width: 153.6rem;
                        margin-left: auto;
                        margin-right: auto;
                    `)}
                    sources={[
                        {minWidthPX: 0, src: sneakPeakSm, height: 2504, width: 720},
                        {minWidthPX: 720, src: sneakPeakXl, height: 1252, width: 1092}
                    ]}
                    alt="header"
                />

                <div css={sneakPeak}>
                    <CloseIcon css={closeIcon} size="2" onClick={onShowListing} />
                    <Text align="center" css={[mb(4), onDesktop(mb(4))]} variant="headline_4">
                        Porównaj{" "}
                        <Highlight
                            css={css`
                                font-weight: 700;
                            `}
                        >
                            12 cech nieruchomości
                        </Highlight>{" "}
                        w jednym miejscu. W tym czasy dojazdu i odległość od personalizowanych punktów.
                    </Text>

                    <div css={flexAbsoluteCenter}>
                        <WeightIcon css={[elevation(4), mr(2)]} size="6" wrapperColor="#fff" wrapperSize="6.4" />
                        <Text css={textLight} variant="body_copy_2">
                            Przeglądając oferty użyj <Highlight>tej ikony</Highlight> , aby dodać do oferty porównywarki.
                        </Text>
                    </div>

                    <Button css={showListingButton} onClick={onShowListing} variant="filled_primary">
                        Wybierz mieszkania do porównania
                    </Button>
                </div>
            </div>
        </div>
    );
};

const closeIcon = css`
    ${pointer};
    position: absolute;
    top: 2.8rem;
    right: 2.6rem;
`;

const emptyDataContainer = () => css`
    position: relative;

    &:before {
        content: "";
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.75;
        position: absolute;
        z-index: 2;
    }

    ${mt(3)};
    ${flexAlignCenter};
    flex-direction: column;

    ${onDesktop(mt(6))}
`;

const comparisonToolSneakPeak = () => css`
    ${flex("normal", "center")};
    ${mt(8)};
    ${mh(1.5)}
    height: 64.8rem;
    position: relative;
    overflow: hidden;

    ${onDesktop(mt(12))}
`;

const sneakPeak = (theme: Theme) => css`
    z-index: 3;
    position: absolute;
    left: 50%;
    top: 7.5rem;
    transform: translateX(-50%);
    background-color: #fff;
    ${flex("center", "center")};
    flex-direction: column;
    ${p(9, 2, 2, 2)};
    ${borderRadius(2)};
    ${w100};
    ${elevation(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        top: 14.2rem;
        ${p(4, 12, 5, 12)};
        text-align: center;
        width: 74.4rem;
        max-width: 74.4rem;
    }
`;

const showListingButton = (theme: Theme) => css`
    ${mt(3)};
    ${pv(2)};
    ${w100};
    white-space: pre-line;

    @media (min-width: ${theme.breakpoints.sm}) {
        ${mt(5)};
        width: auto;
    }
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, color, flex, flexAbsoluteCenter, flexAlignCenter, mb, mh, mr, mt, onDesktop, p, pointer, pv, w100} from "@pg-design/helpers-css";
import {CloseIcon, WeightIcon} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

const sneakPeakSm = require("./images/comparison_tool_sneak_peak_sm.png");
const sneakPeakXl = require("./images/comparison_tool_sneak_peak_xl.png");

export const NoItemsToCompare = () => {
    const theme = useTheme();

    const textLight = color(theme.colors.gray[700]);

    const onShowListing = () => {
        window.location.replace(rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"}));
    };

    return (
        <div css={emptyDataContainer}>
            <div css={comparisonToolSneakPeak}>
                <Picture
                    css={onDesktop(css`
                        max-width: 153.6rem;
                        margin-left: auto;
                        margin-right: auto;
                    `)}
                    sources={[
                        {minWidthPX: 0, src: sneakPeakSm, height: 2504, width: 720},
                        {minWidthPX: 720, src: sneakPeakXl, height: 1252, width: 1092}
                    ]}
                    alt="header"
                />

                <div css={sneakPeak}>
                    <CloseIcon css={closeIcon} size="2" onClick={onShowListing} />
                    <Text align="center" css={[mb(4), onDesktop(mb(4))]} variant="headline_4">
                        Porównaj{" "}
                        <Highlight
                            css={css`
                                font-weight: 700;
                            `}
                        >
                            12 cech nieruchomości
                        </Highlight>{" "}
                        w jednym miejscu. W tym czasy dojazdu i odległość od personalizowanych punktów.
                    </Text>

                    <div css={flexAbsoluteCenter}>
                        <WeightIcon css={[elevation(4), mr(2)]} size="6" wrapperColor="#fff" wrapperSize="6.4" />
                        <Text css={textLight} variant="body_copy_2">
                            Przeglądając oferty użyj <Highlight>tej ikony</Highlight> , aby dodać do oferty porównywarki.
                        </Text>
                    </div>

                    <Button css={showListingButton} onClick={onShowListing} variant="filled_primary">
                        Wybierz mieszkania do porównania
                    </Button>
                </div>
            </div>
        </div>
    );
};

const closeIcon = css`
    ${pointer};
    position: absolute;
    top: 2.8rem;
    right: 2.6rem;
`;

const emptyDataContainer = () => css`
    position: relative;

    &:before {
        content: "";
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.75;
        position: absolute;
        z-index: 2;
    }

    ${mt(3)};
    ${flexAlignCenter};
    flex-direction: column;

    ${onDesktop(mt(6))}
`;

const comparisonToolSneakPeak = () => css`
    ${flex("normal", "center")};
    ${mt(8)};
    ${mh(1.5)}
    height: 64.8rem;
    position: relative;
    overflow: hidden;

    ${onDesktop(mt(12))}
`;

const sneakPeak = (theme: Theme) => css`
    z-index: 3;
    position: absolute;
    left: 50%;
    top: 7.5rem;
    transform: translateX(-50%);
    background-color: #fff;
    ${flex("center", "center")};
    flex-direction: column;
    ${p(9, 2, 2, 2)};
    ${borderRadius(2)};
    ${w100};
    ${elevation(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        top: 14.2rem;
        ${p(4, 12, 5, 12)};
        text-align: center;
        width: 74.4rem;
        max-width: 74.4rem;
    }
`;

const showListingButton = (theme: Theme) => css`
    ${mt(3)};
    ${pv(2)};
    ${w100};
    white-space: pre-line;

    @media (min-width: ${theme.breakpoints.sm}) {
        ${mt(5)};
        width: auto;
    }
`;
